import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import {
  loadProject,
  saveWorkingProjectSession,
  saveWorkingProjectSessionByField,
  setSavingWorkingProject,
  setSavingWorkingProjectError,
  setUpdatingSessionUuid,
  updateMostRecentActivity,
} from '..';
import { UpdateSession } from '@/connection/sessions/update-session';
import { RootState } from '@/store/main';

const saveSessionMiddleware = createListenerMiddleware();

let timeout: NodeJS.Timeout | null = null;

saveSessionMiddleware.startListening({
  matcher: isAnyOf(saveWorkingProjectSession, saveWorkingProjectSessionByField), // comma separated list of actions to listen for
  effect: async (_action, listenerApi) => {
    listenerApi.dispatch(setSavingWorkingProject(true));
    if (timeout) clearTimeout(timeout);

    timeout = setTimeout(async () => {
      const state = listenerApi.getState() as RootState;
      const project = state?.project?.workingProject;
      const updatedSessionUuid = state?.project?.updatedSessionUuid;
      const shouldRefetchProject = state.project.refetchProjectAfterSave;
      if (project && updatedSessionUuid) {
        try {
          const session = project.sessions.find((s) => s.uuid === updatedSessionUuid);
          if (session) {
            await UpdateSession(session);
          }
          listenerApi.dispatch(setSavingWorkingProjectError(null));
          listenerApi.dispatch(updateMostRecentActivity({ isPublish: false }));
        } catch (error: unknown) {
          const errMsg = error instanceof Error ? error.message : 'Error saving working project';
          console.error('Error saving project', error);
          listenerApi.dispatch(setSavingWorkingProjectError(errMsg));
        } finally {
          listenerApi.dispatch(setSavingWorkingProject(false));
          listenerApi.dispatch(setUpdatingSessionUuid(null));
          if (shouldRefetchProject && state.project?.workingProject?.uuid) {
            listenerApi.dispatch(loadProject({ uuid: state.project.workingProject.uuid, doNotSetLoadingState: true }));
          }
        }
      }
    }, 1000);
  },
});

export default saveSessionMiddleware;
